import React from 'react';

import './styles.scss';

const Card = ({
  title,
  value,
  color,
}) => (
  <div className="bvCard" style={{background:color}}>
    <div>
      { title }
    </div>
    <div>
      { value }
    </div>
  </div>
);

const BedVentilatorCard = ({
  title,
  total,
  occupied,
  vacant,
}) => (
  <div className="bedVentilator">
    <Card
      title={title}
      value="→"
    />
    <Card
      title="Total"
      value={total}
      color="linear-gradient(0deg, #397BDF, #397BDF), #FFFFFF"
    />
    <Card
      title="Occupied"
      value={occupied}
      color="linear-gradient(0deg, #FEA842, #FEA842), #397BDF"
    />
    <Card
      title="Vacant"
      value={vacant}
      color="linear-gradient(0deg, #46A047, #46A047), #397BDF"
    />
</div>
);

export default BedVentilatorCard;
